module.exports = __webpack_public_path__ + "img/img@12x.3ae5bee2.webp";